import { render, staticRenderFns } from "./ConceptTaxes.vue?vue&type=template&id=c960954c&scoped=true&"
import script from "./ConceptTaxes.vue?vue&type=script&lang=js&"
export * from "./ConceptTaxes.vue?vue&type=script&lang=js&"
import style0 from "./ConceptTaxes.vue?vue&type=style&index=0&id=c960954c&scoped=true&lang=css&"
import style1 from "./ConceptTaxes.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c960954c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c960954c')) {
      api.createRecord('c960954c', component.options)
    } else {
      api.reload('c960954c', component.options)
    }
    module.hot.accept("./ConceptTaxes.vue?vue&type=template&id=c960954c&scoped=true&", function () {
      api.rerender('c960954c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Admin/Invoices/NewInvoice/ConceptTaxes.vue"
export default component.exports